<template>
    <div id="application">
        <div v-if="isProdEnv" style="z-index:11; width: 100%; position: absolute; top: 0px; background-color: #007bff; opacity: 50%; text-align: center; color: white">
            <p>dev</p>
        </div>
        <router-view></router-view>
    </div>
</template>
<script>
export default {
  name: "App",
};
</script>
<script setup>
import { store } from "@/stores/OpportuniteStore";
import {useRoute, useRouter} from "vue-router";
import extracteurDeParametresUrlMarketing from "./services/extracteurDeParametresUrlMarketing";
import extracteurDeParametresUrlParrainage from "./services/extracteurDeParametresUrlParrainage";

const router = useRouter();
const route = useRoute();

const isProdEnv = process.env.NODE_ENV !== 'production';

router
  .isReady()
  .then(() => {
    store.commit('SET_PARAMETRES_URL_MARKETING', extracteurDeParametresUrlMarketing(route.query))
    store.commit('SET_PARAMETRES_URL_PARRAINAGE', extracteurDeParametresUrlParrainage(route.query))
  })

store.dispatch("setGoogleClientId", $cookies.get("_ga"));
if (localStorage.version === undefined) {
  const getRandomInt = (max) => Math.floor(Math.random() * max);

  const genererLaVersionAffiche = () => {
    const randomInt = getRandomInt(100);
    if (randomInt > 50) {
      return "default";
    } else {
      return "alternative-1";
    }
  };
  localStorage.version = genererLaVersionAffiche();
}
</script>
